import { redirect } from 'react-router-dom'
import { z } from 'zod'

import { useAppointmentStore } from '@/store.ts'
import { isVelthuis } from '@/utils/common.ts'
import { fetchFromApi } from '@/utils/fetchFromApi.ts'

interface ActionData {
  errors?: z.ZodIssue[]
  error?: string
}

const action = async (): Promise<ActionData | Response> => {
  const { patientData, selectedSlot, setError, zdCode } =
    useAppointmentStore.getState()

  const createAppointmentBody = {
    slot: {
      end: selectedSlot?.end,
      id: selectedSlot?.id,
      start: selectedSlot?.start,
    },
    user: {
      birthDate: patientData?.dateOfBirth,
      email: patientData?.email,
      firstName: patientData?.firstName,
      gender: patientData?.gender,
      houseNumber: patientData?.houseNumber,
      initials: patientData?.initials,
      lastName: patientData?.lastName,
      phone: patientData?.phone,
      postalCode: patientData?.postalCode,
    },
    zdCode: zdCode,
  }

  try {
    const response = await fetchFromApi(`appointments/`, {
      body: createAppointmentBody,
      method: 'POST',
    })

    if (response.ok) {
      return redirect('/success')
    } else {
      // TimeFF failed (502) or timed out (504) on the create. Retrying keeps
      // failing for the same patient, so offer the phone instead.
      if (isVelthuis && (response.status === 502 || response.status === 504)) {
        setError('timeffTimeoutVelthuis')
      } else if (response.status === 500) {
        setError('internalServerError')
      } else if (response.status === 400) {
        const data = await response.json()
        if (data?.error?.message.includes('ZD')) {
          setError('zdCode')
        } else {
          setError('default')
        }
      } else {
        setError('default')
      }
      return redirect('/error')
    }
  } catch (error) {
    console.error(error)
    setError('network')
    return redirect('/error')
  }
}

export type { ActionData }
export { action }
